import type { Route } from '~/core/router'

import { entitiesHybridSearchModel } from '~/entities/hybrid-search'
import * as hybrid from '~/routes/search/hybrid'
import * as initial from '~/routes/search/initial'
import * as results from '~/routes/search/results'
import * as root from '~/routes/search/root'
import { aye, nay } from '~/shared/helpers'

export const route: Route = {
  children: [
    {
      path: '',
      component: [initial.Title, initial.SearchPage],
      init: root.model.init,
      left: initial.model.left,
      filter: {
        source: entitiesHybridSearchModel.$hybridSearchAvailable,
        fn: nay,
      },
    },
    {
      path: '/:contentType', // ContentType is for searching by tab that was removed (and that will be added again in future)
      component: [results.Title, results.SearchResultsPage],
      init: root.model.initSearchResultsPage,
      left: results.model.left,
      filter: {
        source: entitiesHybridSearchModel.$hybridSearchAvailable,
        fn: nay,
      },
    },
    {
      path: '',
      component: [hybrid.Title, hybrid.HybridSearchPage],
      init: hybrid.model.init,
      left: hybrid.model.left,
      filter: {
        source: entitiesHybridSearchModel.$hybridSearchAvailable,
        fn: aye,
      },
    },
  ],
}
